module.exports = "/static/media/Frame_669.add3b0fe.png";